import { crpCommunicationsCuratedBaseApi } from "./crpCommunicationsBaseApi"

const onboardingClientUrl = "/connect/client/onboard_client"

export const onboardNewClientApi = crpCommunicationsCuratedBaseApi.injectEndpoints({
    endpoints: (build) => ({
        onboardNewClient: build.mutation({
            query: ({payload: newClientData, id, attachment }) => {
                return {
                    url: `${onboardingClientUrl}/${id}`,
                    method: "POST",
                    body: {newClientData: newClientData, attachment:attachment}
                }
            }
        })
    }),
    overrideExisting: false,
})

export const { useOnboardNewClientMutation } = onboardNewClientApi